export default "__VITE_ASSET__CDQKGG7C__"